<template>
    <div class="table-operation">
        <veui-button v-for="(button, index) in buttonOptions" :key="index"
            class="operation"
            ui="link"
            :ref="`operation-${index}`"
            @click="handleSpreadBtnClick(button, index)"
            :disabled="button.disabled || false">{{ button.label }}</veui-button>
        <veui-dropdown v-if="selectOptions"
            class="operation"
            :options="selectOptions"
            @click="handleOptionClick"
            :disabled="disabled"
            :label="label"/>
    </div>
</template>

<script>
import {Button, Dropdown} from 'veui';

export default {
    name: 'TableOperation',
    components: {
        'veui-button': Button,
        'veui-dropdown': Dropdown
    },
    props: {
        options: Array,
        disabled: Boolean,
        spreadCount: {
            type: Number,
            default: 3
        },
        label: {
            type: String,
            default: '更多'
        }
    },
    computed: {
        buttonOptions() {
            return this.options.length > this.spreadCount
                ? this.options.slice(0, this.spreadCount - 1)
                : this.options;
        },
        selectOptions() {
            return this.options.length > this.spreadCount
                ? this.options
                    .slice(this.spreadCount - 1)
                    .map(item => ({label: item.label, value: item}))
                : null;
        }
    },
    methods: {
        handleSpreadBtnClick(button, index) {
            if (button.needRef) {
                this.$emit(button.event, button.args, this.$refs[`operation-${index}`]);
            }
            else {
                let {event, url, args} = button;
                if (event === 'redirect') {
                    this.$router.push(url);
                    return;
                }
                this.$emit(event, args);
            }
        },
        handleOptionClick({event, url, args}) {
            if (event === 'redirect') {
                this.$router.push(url);
                return;
            }
            this.$emit(event, args);
        }
    }
};
</script>

<style lang="less">
@import "~@/common/css/lib.less";

.table-operation {
    display: inline-block;
    .veui-button+.veui-button {
        margin-left: 10px;
    }
    .veui-dropdown {
        &-button {
            border: 0;
            max-width: 100px;
            position: relative;
            line-height: @veui-height-normal;
            background: transparent;
            .veui-dropdown-icon {
                .absolute(50%, _, _, _);
                transform: translate(0, -50%);
                margin-top: 0;
                margin-left: 2px;
            }
        }
        &-label {
            width: auto;
            max-width: none;
        }
    }
}
</style>
